/* Smukiez's Slot mount: puts the built game (assets/slot-game.js) into a same-origin srcdoc
 * iframe. <base> points at the theme's CDN assets folder so every relative file the game
 * asks for resolves there; rgs_url=demo routes its wallet calls to slot-demo-rgs.js. */
(() => {
  const root = document.querySelector(".smk-slot");
  if (!root) return;
  const stage = root.querySelector("[data-slot-stage]");
  const cover = root.querySelector("[data-slot-cover]");
  const startBtn = root.querySelector("[data-slot-start]");
  const fullBtn = root.querySelector("[data-slot-full]");
  const resetBtn = root.querySelector("[data-slot-reset]");
  const credits = root.querySelector("[data-slot-credits]");
  // the theme's CDN assets folder, from slot-game.js's own URL (strip ?v= and the file name)
  const base = new URL(root.dataset.gameJs, location.href).href.split("?")[0].replace(/[^/]*$/, "");
  const WALLET_KEY = "smukiez.demo.wallet.v1";
  let frame = null;

  const coarse = matchMedia("(pointer: coarse)").matches || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const query = `sessionID=web-${Math.random().toString(36).slice(2, 10)}&rgs_url=demo&lang=en&device=${coarse ? "mobile" : "desktop"}`;

  function loadGameJs() {
    return new Promise((res, rej) => {
      if (window.SMUKIEZ_SLOT_HTML) return res();
      const s = document.createElement("script");
      s.src = root.dataset.gameJs; s.onload = () => res(); s.onerror = () => rej(new Error("slot-game.js failed"));
      document.head.appendChild(s);
    });
  }

  async function mount() {
    startBtn.disabled = true; startBtn.textContent = "Loading…";
    try { await loadGameJs(); }
    catch (e) { startBtn.disabled = false; startBtn.textContent = "Retry"; return; }
    const html = window.SMUKIEZ_SLOT_HTML.replace("__SLOT_BASE__", base).replace("__SLOT_QUERY__", JSON.stringify(query));
    frame = document.createElement("iframe");
    frame.className = "smk-slot__frame";
    frame.title = "Smukiez's Slot";
    frame.setAttribute("allow", "autoplay; fullscreen");
    frame.srcdoc = html;
    stage.appendChild(frame);
    cover.classList.add("is-hidden");
    root.classList.add("is-playing");
    tickCredits();
  }

  function tickCredits() {
    try {
      const w = JSON.parse(localStorage.getItem(WALLET_KEY) || "null");
      if (w && typeof w.balance === "number") {
        credits.hidden = false;
        credits.textContent = (w.balance / 1e6).toLocaleString(undefined, { style: "currency", currency: "USD" }) + " credits";
      }
    } catch (e) { /* no storage */ }
    if (frame) setTimeout(tickCredits, 1500);
  }

  startBtn.addEventListener("click", mount);
  resetBtn.addEventListener("click", () => {
    try { localStorage.removeItem(WALLET_KEY); } catch (e) { /* ignore */ }
    if (frame) { frame.remove(); frame = null; mount(); }
    else tickCredits();
  });
  fullBtn.addEventListener("click", () => {
    const el = stage;
    if (document.fullscreenElement) document.exitFullscreen();
    else if (el.requestFullscreen) el.requestFullscreen().catch(() => {});
  });
  document.addEventListener("fullscreenchange", () => root.classList.toggle("is-fullscreen", !!document.fullscreenElement));
})();
